// extracted by mini-css-extract-plugin
module.exports = {"statusMessage":"styles_statusMessage__QJGc7","loader":"styles_loader__28nr_","spin":"styles_spin__1eg1P"};